/**
 * Translation helpers for consistent Lithuanian language display
 */

// TV Show status translations
export const TV_STATUS_LT = {
  'Returning Series': 'Grįžtantis serialas',
  'Planned': 'Planuojama',
  'In Production': 'Gaminama',
  'Ended': 'Pasibaigęs',
  'Canceled': 'Atšauktas',
  'Pilot': 'Pilotas'
};

// Movie status translations
export const MOVIE_STATUS_LT = {
  'Released': 'Išleistas',
  'Post Production': 'Post-produkcija',
  'In Production': 'Gaminama',
  'Planned': 'Planuojama',
  'Rumored': 'Gandai',
  'Canceled': 'Atšauktas'
};

// Country code to Lithuanian name mapping (common countries)
export const COUNTRY_NAMES_LT = {
  'US': 'JAV',
  'GB': 'Didžioji Britanija',
  'UK': 'Didžioji Britanija',
  'FR': 'Prancūzija',
  'DE': 'Vokietija',
  'IT': 'Italija',
  'ES': 'Ispanija',
  'JP': 'Japonija',
  'KR': 'Pietų Korėja',
  'CN': 'Kinija',
  'IN': 'Indija',
  'CA': 'Kanada',
  'AU': 'Australija',
  'MX': 'Meksika',
  'BR': 'Brazilija',
  'RU': 'Rusija',
  'SE': 'Švedija',
  'NO': 'Norvegija',
  'DK': 'Danija',
  'FI': 'Suomija',
  'PL': 'Lenkija',
  'CZ': 'Čekija',
  'NL': 'Nyderlandai',
  'BE': 'Belgija',
  'AT': 'Austrija',
  'CH': 'Šveicarija',
  'IE': 'Airija',
  'NZ': 'Naujoji Zelandija',
  'ZA': 'Pietų Afrika',
  'AR': 'Argentina',
  'CL': 'Čilė',
  'CO': 'Kolumbija',
  'TR': 'Turkija',
  'GR': 'Graikija',
  'PT': 'Portugalija',
  'LT': 'Lietuva',
  'LV': 'Latvija',
  'EE': 'Estija',
  'UA': 'Ukraina'
};

// Language code to Lithuanian name mapping
export const LANGUAGE_NAMES_LT = {
  'en': 'Anglų',
  'lt': 'Lietuvių',
  'fr': 'Prancūzų',
  'de': 'Vokiečių',
  'it': 'Italų',
  'es': 'Ispanų',
  'ja': 'Japonų',
  'ko': 'Korėjiečių',
  'zh': 'Kinų',
  'ru': 'Rusų',
  'pl': 'Lenkų',
  'pt': 'Portugalų',
  'sv': 'Švedų',
  'no': 'Norvegų',
  'da': 'Danų',
  'fi': 'Suomių',
  'nl': 'Olandų',
  'cs': 'Čekų',
  'uk': 'Ukrainiečių',
  'el': 'Graikų',
  'tr': 'Turkų',
  'ar': 'Arabų',
  'hi': 'Hindi',
  'th': 'Tailandiečių',
  'vi': 'Vietnamiečių'
};

/**
 * Translate TV show status to Lithuanian
 * @param {string} status - English status
 * @returns {string} Lithuanian status
 */
export function translateTVStatus(status) {
  return TV_STATUS_LT[status] || status;
}

/**
 * Translate movie status to Lithuanian
 * @param {string} status - English status
 * @returns {string} Lithuanian status
 */
export function translateMovieStatus(status) {
  return MOVIE_STATUS_LT[status] || status;
}

/**
 * Translate country code to Lithuanian country name
 * @param {string} countryCode - ISO country code (e.g., 'US')
 * @returns {string} Lithuanian country name
 */
export function translateCountry(countryCode) {
  if (!countryCode) return '';
  return COUNTRY_NAMES_LT[countryCode.toUpperCase()] || countryCode;
}

/**
 * Translate language code to Lithuanian language name
 * @param {string} languageCode - ISO language code (e.g., 'en')
 * @returns {string} Lithuanian language name
 */
export function translateLanguage(languageCode) {
  if (!languageCode) return '';
  return LANGUAGE_NAMES_LT[languageCode.toLowerCase()] || languageCode.toUpperCase();
}

